// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StudentBadgeRepresentation } from './StudentBadgeRepresentation'
import {
  StudentBadgeRepresentationFromJSON,
  StudentBadgeRepresentationFromJSONTyped,
  StudentBadgeRepresentationToJSON,
} from './StudentBadgeRepresentation'

/**
 *
 * @export
 * @interface StudentBadgeRepresentationBaseApiListResult
 */
export interface StudentBadgeRepresentationBaseApiListResult {
  /**
   *
   * @type {Array<StudentBadgeRepresentation>}
   * @memberof StudentBadgeRepresentationBaseApiListResult
   */
  data: Array<StudentBadgeRepresentation>
  /**
   *
   * @type {number}
   * @memberof StudentBadgeRepresentationBaseApiListResult
   */
  total: number
}

/**
 * Check if a given object implements the StudentBadgeRepresentationBaseApiListResult interface.
 */
export function instanceOfStudentBadgeRepresentationBaseApiListResult(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'data' in value
  isInstance = isInstance && 'total' in value

  return isInstance
}

export function StudentBadgeRepresentationBaseApiListResultFromJSON(
  json: any,
): StudentBadgeRepresentationBaseApiListResult {
  return StudentBadgeRepresentationBaseApiListResultFromJSONTyped(json, false)
}

export function StudentBadgeRepresentationBaseApiListResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentBadgeRepresentationBaseApiListResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(StudentBadgeRepresentationFromJSON),
    total: json['total'],
  }
}

export function StudentBadgeRepresentationBaseApiListResultToJSON(
  value?: StudentBadgeRepresentationBaseApiListResult | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(StudentBadgeRepresentationToJSON),
    total: value.total,
  }
}
